import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

const getSamlObjectsResponse = (response) => {
	const { samlObjects } = response.data;

	const samlObjectIDs = samlObjects.map((object) => object.id);

	const samlObjectMap = samlObjects.reduce((acc, currentValue) => {
		const accumulator = acc;
		accumulator[currentValue.id] = currentValue;

		return accumulator;
	}, {});

	return fromJS({
		samlObjectIDs,
		samlObjects: fromJS(samlObjectMap),
	});
};

export const getSamlObjects = CreateProcess({
	method: "GET",
	name: "GetSamlObjects",
	type: "AUTHENTICATION:GETSAMLOBJECTS",

	request: () => ({
		url: "/api/authentication/saml/",
	}),

	success: getSamlObjectsResponse,
});

export const updateSamlObject = CreateProcess({
	method: "POST",
	name: "UpdateSamlObject",
	type: "AUTHENTICATION:UPDATESAMLOBJECT",

	request: (props) => ({
		url: `/api/authentication/saml/${props.samlID}/`,
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const createSamlObject = CreateProcess({
	method: "POST",
	name: "CreateSamlObject",
	type: "AUTHENTICATION:UPDATESAMLOBJECT",

	request: (props) => ({
		url: "/api/authentication/saml/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const deleteSamlObject = CreateProcess({
	method: "DELETE",
	name: "DeleteSamlObject",
	type: "AUTHENTICATION:DELETESAMLOBJECT",

	request: (props) => ({
		url: `/api/authentication/saml/${props.samlID}/`,
	}),

	success: (response) => fromJS(response.data),
});

const authenticationMethodsResponse = (response) => {
	const { availableAuthenticationMethods } = response.data;

	// retain the order from the server.
	const authenticationTypes = availableAuthenticationMethods.map((object) => (object.id ? object.id : object.type));

	// create a map for easy access
	const authenticationMap = availableAuthenticationMethods.reduce((acc, val) => {
		const value = val;
		const accumulator = acc;

		// only saml objects have an id, the other methods of a 'type' key
		// that is unique. For example: google, office365, etc.
		const identifier = value.id ? value.id : value.type;
		value.internal = { identifier };

		accumulator[identifier] = value;
		return accumulator;
	}, {});

	return fromJS({
		authenticationMap,
		authenticationTypes,
	});
};

export const getAuthenticationMethods = CreateProcess({
	method: "GET",
	name: "GetAuthenticationMethods",
	type: "AUTHENTICATION:GETMETHODS",

	request: () => ({
		url: "/api/authentication/methods/",
	}),

	success: authenticationMethodsResponse,
});

export const updateAuthenticationMethods = CreateProcess({
	method: "POST",
	name: "UpdateAuthenticationMethods",
	type: "AUTHENTICATION:UPDATEMETHODS",

	request: (props) => ({
		url: "/api/authentication/methods/",
		payload: props.payload,
	}),

	success: authenticationMethodsResponse,
});

export const getEnabledAuthenticationMethods = CreateProcess({
	method: "GET",
	name: "GetEnabledAuthenticationMethods",
	type: "AUTHENTICATION:GETENABLEDMETHODS",

	request: (props) => ({
		url: `/api/public/authentication/methods/?email=${encodeURIComponent(props.email)}`,
	}),

	success: (response) => {
		const companyEnabledAuthenticationMethods = response.data.enabledAuthenticationMethods;

		return fromJS({
			companyEnabledAuthenticationMethods,
		});
	},
});

export const userEmailAndPasswordLogin = CreateProcess({
	method: "POST",
	name: "UserEmailAndPasswordLogin",
	type: "AUTHENTICATION:EMAILANDPASSWORD",

	request: (props) => ({
		url: "/api/public/authentication/login/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const changePassword = CreateProcess({
	method: "POST",
	name: "changePassword",
	type: "AUTHENTICATION:CHANGEPASSWORD",

	request: (props) => ({
		url: "/api/user/reset-password/",
		payload: {
			newPassword: props.newPassword,
			existingPassword: props.oldPassword,
		},
	}),

	success: (response) => fromJS(response.data),
});
